import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  FileUpload,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Switch,
  DarkMode,
  Select,
  color,
  IconButton,
  Checkbox,
  background,
  Badge,
  Textarea,
  Image,
  useToast,
} from "@chakra-ui/react";

// Images

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";
import BillingRow from "components/Tables/BillingRow";

// Data
import { billingData } from "variables/general";
import { AddIcon } from "@chakra-ui/icons";
import useApiReq from "variables/apireq";
import OrderPackageModal from "views/Order/OrderPackageModal";
import { useLoader } from "components/Loader/loader";
import { FaClosedCaptioning, FaCross } from "react-icons/fa";
import { AiFillCloseCircle, AiFillCloseSquare } from "react-icons/ai";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import GroupModal from "./PRGroupAdd";
import { motion } from "framer-motion";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";

const locationList = [
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Dhaka", value: "Dhaka" },
  { label: "Chattogram", value: "Chattogram" },
  { label: "Khulna", value: "Khulna" },
  { label: "Rajshahi", value: "Rajshahi" },
  { label: "Sylhet", value: "Sylhet" },
  { label: "Barishal", value: "Barishal" },
  { label: "Rangpur", value: "Rangpur" },
  { label: "Mymensingh", value: "Mymensingh" },
];

// const locationList = [
//   { label: "Bagerhat", value: "Bagerhat" },
//   { label: "Bandarban", value: "Bandarban" },
//   { label: "Barguna", value: "Barguna" },
//   { label: "Barishal", value: "Barishal" },
//   { label: "Bhola", value: "Bhola" },
//   { label: "Bogura", value: "Bogura" },
//   { label: "Brahmanbaria", value: "Brahmanbaria" },
//   { label: "Chandpur", value: "Chandpur" },
//   { label: "Chattogram", value: "Chattogram" },
//   { label: "Chuadanga", value: "Chuadanga" },
//   { label: "Cox's Bazar", value: "Cox's Bazar" },
//   { label: "Cumilla", value: "Cumilla" },
//   { label: "Dhaka", value: "Dhaka" },
//   { label: "Dinajpur", value: "Dinajpur" },
//   { label: "Faridpur", value: "Faridpur" },
//   { label: "Feni", value: "Feni" },
//   { label: "Gaibandha", value: "Gaibandha" },
//   { label: "Gazipur", value: "Gazipur" },
//   { label: "Gopalganj", value: "Gopalganj" },
//   { label: "Habiganj", value: "Habiganj" },
//   { label: "Jamalpur", value: "Jamalpur" },
//   { label: "Jashore", value: "Jashore" },
//   { label: "Jhalokathi", value: "Jhalokathi" },
//   { label: "Jhenaidah", value: "Jhenaidah" },
//   { label: "Joypurhat", value: "Joypurhat" },
//   { label: "Khagrachari", value: "Khagrachari" },
//   { label: "Khulna", value: "Khulna" },
//   { label: "Kishoreganj", value: "Kishoreganj" },
//   { label: "Kurigram", value: "Kurigram" },
//   { label: "Kushtia", value: "Kushtia" },
//   { label: "Lakshmipur", value: "Lakshmipur" },
//   { label: "Lalmonirhat", value: "Lalmonirhat" },
//   { label: "Madaripur", value: "Madaripur" },
//   { label: "Magura", value: "Magura" },
//   { label: "Manikganj", value: "Manikganj" },
//   { label: "Meherpur", value: "Meherpur" },
//   { label: "Moulvibazar", value: "Moulvibazar" },
//   { label: "Munshiganj", value: "Munshiganj" },
//   { label: "Mymensingh", value: "Mymensingh" },
//   { label: "Naogaon", value: "Naogaon" },
//   { label: "Narail", value: "Narail" },
//   { label: "Narayanganj", value: "Narayanganj" },
//   { label: "Narsingdi", value: "Narsingdi" },
//   { label: "Natore", value: "Natore" },
//   { label: "Netrokona", value: "Netrokona" },
//   { label: "Nilphamari", value: "Nilphamari" },
//   { label: "Noakhali", value: "Noakhali" },
//   { label: "Pabna", value: "Pabna" },
//   { label: "Panchagarh", value: "Panchagarh" },
//   { label: "Patuakhali", value: "Patuakhali" },
//   { label: "Pirojpur", value: "Pirojpur" },
//   { label: "Rajbari", value: "Rajbari" },
//   { label: "Rajshahi", value: "Rajshahi" },
//   { label: "Rangamati", value: "Rangamati" },
//   { label: "Rangpur", value: "Rangpur" },
//   { label: "Satkhira", value: "Satkhira" },
//   { label: "Shariatpur", value: "Shariatpur" },
//   { label: "Sherpur", value: "Sherpur" },
//   { label: "Sirajganj", value: "Sirajganj" },
//   { label: "Sunamganj", value: "Sunamganj" },
//   { label: "Sylhet", value: "Sylhet" },
//   { label: "Tangail", value: "Tangail" },
//   { label: "Thakurgaon", value: "Thakurgaon" },
// ];

const targetingList = [
  { label: "Age", value: "Age" },
  { label: "Rich", value: "Rich" },
  { label: "Poor", value: "Poor" },
  { label: "Middle Class", value: "Middle Class" },
];
const ageGroupList = [
  { label: "All", value: "all" },
  { label: "18-24", value: "18-24" },
  { label: "25-34", value: "25-34" },
  { label: "35-44", value: "35-44" },
  { label: "45-54", value: "45-54" },
  { label: "55-64", value: "55-64" },
  { label: "65+", value: "65+" },
  // { label: "All", value: "All" },
];

const interestsList = [
  { label: "All", value: "All" },
  { label: "Advertising & Marketing", value: "Advertising & Marketing" },
  { label: "Agriculture", value: "Agriculture" },
  { label: "Architecture", value: "Architecture" },
  { label: "Aviation", value: "Aviation" },
  { label: "Banking", value: "Banking" },
  { label: "Business", value: "Business" },
  { label: "Construction", value: "Construction" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Design", value: "Design" },
  { label: "Economics", value: "Economics" },
  { label: "Engineering", value: "Engineering" },
  { label: "Entrepreneurship", value: "Entrepreneurship" },
  { label: "Health Care", value: "Health Care" },
  { label: "Higher Education", value: "Higher Education" },
  { label: "Management", value: "Management" },
  { label: "Nursing", value: "Nursing" },
  { label: "Online Marketing", value: "Online Marketing" },
  { label: "Personal Finance", value: "Personal Finance" },
  { label: "Retail", value: "Retail" },
  { label: "Sales", value: "Sales" },
  { label: "Science", value: "Science" },
  { label: "Small business", value: "Small business" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "Games", value: "Games" },
  { label: "Live Events", value: "Live Events" },
  { label: "Movies", value: "Movies" },
  { label: "Music", value: "Music" },
  { label: "Reading", value: "Reading" },
  { label: "TV", value: "TV" },
  { label: "Fitness and wellness", value: "Fitness and wellness" },
  { label: "Yoga", value: "Yoga" },
  { label: "Food and drink", value: "Food and drink" },
  { label: "Hobbies and activities", value: "Hobbies and activities" },
  { label: "Travel", value: "Travel" },
  { label: "Vehicles", value: "Vehicles" },
  { label: "Shopping and fashion", value: "Shopping and fashion" },
  { label: "Sports and outdoors", value: "Sports and outdoors" },
  { label: "Technology", value: "Technology" },
];

function CreateCampaign() {
  const titleColor = "white";
  const textColor = "gray.400";
  const [data, setData] = useState([]);
  const [hidden, setHidden] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const { setIsLoading, isLoading } = useLoader();
  const [groups, setGroups] = useState([]);
  const [selectedTargeting, setSelectedTargeting] = useState([]);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedAgeGroup, setSelectedAgeGroup] = useState([]);
  const [getOrderByType, setGetOrderByType] = useState([]);
  const [isgroupUpdated, setGroupUpdated] = useState(false);
  const [selectedbanner, setSelectedBanner] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const history = useHistory();
  const [isInvalid, setIsInvalid] = useState(false);
  const [isTypeShown, setIsTypeShown] = useState(false);
  const [isShowAnalytics, setIsShowAnalytics] = useState(false);
  const toast = useToast({ position: "top" });

  const [formData, setFormData] = useState({
    prTopic: "",
    socialMedia: false,
    analytics: false,
    prgroup: "",
    ageGroup: "",
    gender: "",
    locationList: "",
    targetingList: "",
    interestsList: "",
    content: "",
    banner: "",
    advertiser: "",
    prType: "",
    package: "",
  });

  const setIsOpen = () => {
    setOpen(!isOpen);
  };

  const hide = () => {
    setHidden(!hidden);
  };

  useEffect(() => {
    if (selectedLocation) {
      const first10 = selectedLocation.map((item) => item.value).splice(0, 5);
      const rest =
        selectedLocation.length > 5
          ? ` +${selectedLocation.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        locationList: first10.join(", ") + rest,
      }));
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (selectedTargeting) {
      const first10 = selectedTargeting.map((item) => item.value).splice(0, 5);
      const rest =
        selectedTargeting.length > 5
          ? ` +${selectedTargeting.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        targetingList: first10.join(", ") + rest,
      }));
    }
  }, [selectedTargeting]);

  useEffect(() => {
    if (selectedInterests) {
      const first10 = selectedInterests.map((item) => item.value).splice(0, 5);
      const rest =
        selectedInterests.length > 5
          ? ` +${selectedInterests.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        interestsList: first10.join(", ") + rest,
      }));
    }
  }, [selectedInterests]);

  useEffect(() => {
    if (selectedAgeGroup) {
      const first10 = selectedAgeGroup.map((item) => item.value).splice(0, 5);
      const rest =
        selectedAgeGroup.length > 5
          ? ` +${selectedAgeGroup.length - 5} more`
          : "";
      setFormData((prev) => ({
        ...prev,
        selectedAgeGroup: first10.join(", ") + rest,
      }));
    }
  }, [selectedAgeGroup]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // console.log("name", name);
    // console.log("value", value);
    // console.log("type", type);
    // console.log("checked", checked);
    // console.log("files", files);

    if (name === "advertiser" && value !== "") {
      setIsTypeShown(true);
    }

    if (name === "prType" && value === "Online&Analytic") {
      setIsShowAnalytics(true);
    }

    if (name === "prType" && value !== "Online&Analytic") {
      setIsShowAnalytics(false);
    }

    if (name === "prType" && value !== "") {
      fetchOrder(value);
    }

    if (name === "content") {
      // convert to base64
      const file = e.target.files[0];
      if (file) {
        setIsInvalid(false);

        if (file.size > 1 * 1024 * 1024) {
          e.target.value = null;
          toast({
            title: "ALART",
            description: "File Size Is Too Large",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          setIsInvalid(true);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          setSelectedContent(reader.result);
        };
      }
    }

    if (name === "banner") {
      const newFiles = Array.from(files);

      if (newFiles.length > 5) {
        toast({
          title: "ALERT",
          description: "You can only upload up to 5 files",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      const fileReaders = [];
      const previews = [];

      newFiles.forEach((file) => {
        if (file.size > 1 * 1024 * 1024) {
          toast({
            title: "ALERT",
            description: `File "${file.name}" is too large`,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
          return;
        }

        const reader = new FileReader();
        fileReaders.push(
          new Promise((resolve) => {
            reader.onloadend = () => resolve({ file, preview: reader.result });
          })
        );
        reader.readAsDataURL(file);
      });

      Promise.all(fileReaders).then((results) => {
        setSelectedBanner((prev) => [
          ...prev,
          ...results.map((res) => res.preview),
        ]);

        setFormData((prev) => ({
          ...prev,
          banner: [...prev.banner, ...results.map((res) => res.file)],
        }));
      });

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const removeBannerItem = (indexToRemove) => {
    setSelectedBanner((prev) => prev.filter((_, i) => i !== indexToRemove));
    setFormData((prev) => ({
      ...prev,
      banner: prev.banner.filter((_, i) => i !== indexToRemove),
    }));
  };

  const handleEmptyFields = () => {
    setFormData((prev) =>
      Object.fromEntries(
        Object.entries(prev).filter(([_, value]) => value && value.length > 0)
      )
    );
  };

  const fetchCampaignGroup = async () => {
    try {
      const res = await useApiReq({
        method: "GET",
        url: "group/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setGroups(res.response);
      }
    } catch (err) {
      setError(err);
    }
  };

  const groupUpdated = () => {
    setGroupUpdated(!isgroupUpdated);
  };

  const fetchAdvertiser = async () => {
    try {
      const res = await useApiReq({
        method: "GET",
        url: "advertiser/list/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response);
        if (localStorage.getItem("group") === "Advertiser") {
          handleChange({
            target: { name: "advertiser", value: res.response[0].uuid },
          });
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      await fetchCampaignGroup();
      if (isgroupUpdated) {
        groupUpdated();
      }

      setIsLoading(false);
    }
  };

  const fetchOrder = async (prType) => {
    if (!formData.advertiser) {
      setGetOrderByType([]);
      setFormData((prev) => ({ ...prev, package: "" }));
      return;
    }

    try {
      setIsLoading(true);
      const params = new URLSearchParams({
        advertiser_uuid: formData.advertiser,
        type: prType,
      });
      const res = await useApiReq({
        method: "GET",
        url: `order/` + `?${params.toString()}`,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
        setGetOrderByType([]);
        setFormData((prev) => ({ ...prev, package: "" }));
      } else {
        setGetOrderByType(res.response || []);
        // Reset package selection if no packages available
        if (!res.response || res.response.length === 0) {
          setFormData((prev) => ({ ...prev, package: "" }));
          setError(
            "No available packages for this advertiser. Please select a different advertiser or create an order first."
          );
        } else {
          setError(null);
        }
      }
    } catch (err) {
      setError(
        err?.message || err || "Failed to fetch packages. Please try again."
      );
      setGetOrderByType([]);
      setFormData((prev) => ({ ...prev, package: "" }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvertiser();
  }, []);

  const fetchCreateCampaing = async (data) => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await useApiReq({
        method: "POST",
        url: "campaign/add/",
        data: data,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        // Parse error message to show user-friendly message
        let errorMessage = res.error?.message || res.error;

        // Handle dictionary-style error messages from backend
        if (typeof errorMessage === "string") {
          // Check for package-related errors
          if (errorMessage.includes("package")) {
            const packageErrorMatch = errorMessage.match(
              /['"]package['"]:\s*ErrorDetail\(string=['"]([^'"]+)['"]/
            );
            if (packageErrorMatch) {
              errorMessage =
                packageErrorMatch[1] +
                " Please select a different advertiser or create an order first.";
            } else if (errorMessage.includes("No available packages")) {
              errorMessage =
                "No available packages for this advertiser. Please select a different advertiser or create an order first.";
            }
          }
        }

        setError(errorMessage);
      } else {
        toast({
          title: "Success",
          description: "Campaign Created Successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setFormData({
          prTopic: "",
          type: "",
          socialMedia: false,
          analytics: false,
          prgroup: "",
          brandName: "",
          objective: "",
          additionalInfo: "",
          banner: "",
          content: "",
          advertiser: "",
          prType: "",
          package: "",
        });
        setSelectedBanner([]);
        if (hidden) {
          hide();
        }
        fetchAdvertiser();
        history.push(`/${localStorage.getItem("group").toLowerCase()}/pr/list`);
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      // Parse error message to show user-friendly message
      let errorMessage = error;

      // Handle dictionary-style error messages from backend
      if (typeof error === "string") {
        // Check for common error patterns
        if (error.includes("No available packages")) {
          errorMessage =
            "No available packages for this advertiser. Please select a different advertiser or create an order first.";
        } else if (error.includes("package")) {
          // Try to extract error message from dictionary format
          const packageErrorMatch = error.match(
            /['"]package['"]:\s*ErrorDetail\(string=['"]([^'"]+)['"]/
          );
          if (packageErrorMatch) {
            errorMessage = packageErrorMatch[1];
          }
        }
      } else if (typeof error === "object" && error.message) {
        errorMessage = error.message;
      }

      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 7000,
        isClosable: true,
      });
    }
  }, [error]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if packages are available
    if (getOrderByType.length === 0) {
      toast({
        title: "Error",
        description:
          "No available packages for this advertiser. Please select a different advertiser or create an order first.",
        status: "error",
        duration: 7000,
        isClosable: true,
      });
      return;
    }

    if (
      formData.prTopic === "" ||
      formData.brandName === "" ||
      formData.objective === "" ||
      formData.advertiser === "" ||
      formData.prType === "" ||
      formData.package === "" ||
      selectedbanner.length === 0 ||
      selectedContent === ""
    ) {
      toast({
        title: "Error",
        description: "Please fill all the required fields",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const data = {
      name: formData.prTopic,
      brand_name: formData.brandName,
      objective: formData.objective,
      additional_info: formData.additionalInfo,
      type: formData.prType,
      content: selectedContent,
      banner: JSON.stringify(selectedbanner),
      is_facebook: formData.socialMedia,
      is_analytics: formData.analytics,
      advertiser_uuid: formData.advertiser,
      package_uuid: formData.package,

      age_groups:
        selectedAgeGroup.length > 0
          ? selectedAgeGroup.map((item) => item.value)
          : [],
      gender: formData.gender,
      location_list:
        selectedLocation.length > 0
          ? selectedLocation.map((item) => item.value)
          : [],
      // targeting_list:
      //   selectedTargeting.length > 0
      //     ? selectedTargeting.map((item) => item.value)
      //     : [],
      targeting_list:
        selectedInterests.length > 0
          ? selectedInterests.map((item) => item.value)
          : [],
    };
    if (formData.prgroup) {
      data.group_uuid = formData.prgroup;
    } else {
      data.group = null;
    }
    fetchCreateCampaing(data);
  };

  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
        {/* Form */}
        <Card p="16px">
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                PR Create
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <GradientBorder
                p="2px"
                ml={{ base: "0px", lg: "24px" }}
                w="100%"
                me={{ base: "none", lg: "30px", xl: "none" }}
                background="transparent"
                boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                borderRadius="30px"
              >
                <Flex
                  background="transparent"
                  borderRadius="30px"
                  direction="column"
                  p="40px"
                  minW={{ base: "unset", md: "430px", xl: "450px" }}
                  w="100%"
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,.5)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <FormControl>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Topic
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="PR Topic"
                          name="prTopic"
                          required
                          value={formData.prTopic}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Select Advertiser
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          _disabled={{
                            background: "rgb(19,21,54) !important",
                            base: "rgb(19,21,54) !important",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          disabled={
                            localStorage.getItem("group") === "Advertiser"
                          }
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          name="advertiser"
                          placeholder="Select Advertiser"
                          value={formData.advertiser}
                          onChange={handleChange}
                          required
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          {data?.map((item) => (
                            <option key={item.uuid} value={item.uuid}>
                              {item.user.username}
                            </option>
                          ))}
                        </Select>
                      </GradientBorder>

                      {!hidden && (
                        <Flex gap={4} justify="space-between" align="center">
                          <div style={{ width: "100%" }}>
                            <FormLabel
                              color={titleColor}
                              ms="4px"
                              fontSize="sm"
                              fontWeight="normal"
                            >
                              PR Group
                            </FormLabel>

                            <GradientBorder
                              mb="24px"
                              h="50px"
                              w={{ base: "100%", lg: "100%" }}
                              borderRadius="20px"
                            >
                              <Select
                                color={titleColor}
                                bg={{
                                  base: "rgb(19,21,54)",
                                }}
                                border="transparent"
                                borderRadius="20px"
                                fontSize="sm"
                                size="lg"
                                w={{ base: "100%", lg: "100%" }}
                                maxW="100%"
                                h="46px"
                                required={false}
                                type="text"
                                placeholder="Select Group"
                                name="prgroup"
                                value={formData.prgroup || ""}
                                onChange={handleChange}
                                sx={{
                                  option: {
                                    backgroundColor: "rgb(19,21,54)",
                                    color: "white",
                                  },
                                }}
                              >
                                {groups?.map((item) => (
                                  <option key={item.uuid} value={item.uuid}>
                                    {item.group_name}
                                  </option>
                                ))}
                              </Select>
                            </GradientBorder>
                          </div>
                          <IconButton
                            aria-label="Add"
                            icon={<Icon as={AddIcon} />}
                            size="md"
                            mt="5px"
                            color={"white"}
                            colorScheme="brand"
                            onClick={setIsOpen}
                            variant="solid"
                          />
                          <IconButton
                            aria-label="Add"
                            icon={<Icon as={AiFillCloseCircle} />}
                            size="md"
                            mt="5px"
                            color={"white"}
                            colorScheme="brand"
                            onClick={hide}
                            variant="solid"
                          />
                        </Flex>
                      )}

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Brand Name
                      </FormLabel>

                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type="text"
                          placeholder="Brand Name"
                          name="brandName"
                          value={formData.brandName}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        PR Type
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          _disabled={{
                            background: "rgb(19,21,54) !important",
                            base: "rgb(19,21,54) !important",
                            cursor: "not-allowed",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          required={false}
                          type="text"
                          placeholder="Select PR Type"
                          name="prType"
                          value={formData.prType}
                          onChange={handleChange}
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                          disabled={!isTypeShown}
                        >
                          <option value="Online">Online</option>
                          <option value="Print">Print</option>
                          <option value="Online&Analytic">
                            Online&Analytic
                          </option>
                        </Select>
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Select Package
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Select
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          _disabled={{
                            background: "rgb(19,21,54) !important",
                            base: "rgb(19,21,54) !important",
                            cursor: "not-allowed",
                            opacity: 0.6,
                          }}
                          border="transparent"
                          borderRadius="20px"
                          disabled={
                            getOrderByType.length === 0 ||
                            !formData.prType ||
                            !formData.advertiser
                          }
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          name="package"
                          placeholder={
                            !formData.advertiser
                              ? "Select Advertiser first"
                              : !formData.prType
                              ? "Select PR Type first"
                              : getOrderByType.length === 0
                              ? "No packages available"
                              : "Select Package"
                          }
                          value={formData.package}
                          onChange={handleChange}
                          required
                          sx={{
                            option: {
                              backgroundColor: "rgb(19,21,54)",
                              color: "white",
                            },
                          }}
                        >
                          {getOrderByType.length === 0 ? (
                            <option value="" disabled>
                              No packages available for this advertiser
                            </option>
                          ) : (
                            getOrderByType?.map((item) => (
                              <option key={item.uuid} value={item.uuid}>
                                {item.package_name}
                              </option>
                            ))
                          )}
                        </Select>
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Objective
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Objective"
                          name="objective"
                          value={formData.objective}
                          onChange={handleChange}
                          required
                        />
                      </GradientBorder>
                      {/* <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Content
                      </FormLabel> */}

                      {/* <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Content"
                          name="content"
                          value={formData.content}
                          onChange={handleChange}
                        />
                      </GradientBorder> */}
                      <Flex
                        direction="row"
                        justifyContent={"space-between"}
                        align="center"
                        w={"100%"}
                        mb="14px"
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Content
                        </FormLabel>

                        <Input
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          maxBlockSize={"200px"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w="auto"
                          type="file"
                          pt={1}
                          sx={{
                            "::file-selector-button": {
                              background: "rgb(30,33,80)",
                              color: "white",
                              padding: "10px 20px",
                              borderRadius: "10px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            },
                            "::file-selector-button:hover": {
                              background: "rgb(40,45,100)",
                              cursor: "pointer",
                            },
                          }}
                          accept=".pdf,.ppt,.pptx,.xls,.xlsx,.doc,.docx,.txt"
                          placeholder="Content"
                          name="content"
                          isInvalid={isInvalid}
                          value={formData.content}
                          onChange={handleChange}
                          required
                        />
                      </Flex>
                      <Flex
                        direction="row"
                        justifyContent={"space-between"}
                        align="center"
                        w={"100%"}
                        mb="14px"
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Banner
                        </FormLabel>

                        <Input
                          color={titleColor}
                          bg={{
                            base: "transparent",
                          }}
                          maxBlockSize={"200px"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w="auto"
                          type="file"
                          multiple
                          pt={1}
                          sx={{
                            "::file-selector-button": {
                              background: "rgb(30,33,80)",
                              color: "white",
                              padding: "10px 20px",
                              borderRadius: "10px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "14px",
                            },
                            "::file-selector-button:hover": {
                              background: "rgb(40,45,100)",
                              cursor: "pointer",
                            },
                          }}
                          placeholder="Banner"
                          name="banner"
                          id="bannerInput"
                          isInvalid={isInvalid}
                          // value={formData.banner}
                          onChange={handleChange}
                          style={{ display: "none" }}
                          disabled={selectedbanner.length >= 5}
                        />

                        <Flex
                          direction="row"
                          justifyContent={"flex-end"}
                          align="center"
                          w={"100%"}
                          mb="14px"
                          mr="28px"
                          gap={2}
                        >
                          <Button
                            onClick={() =>
                              document.getElementById("bannerInput").click()
                            }
                            bg="rgb(30,33,80)"
                            color="white"
                            px="20px"
                            py="10px"
                            borderRadius="10px"
                            fontSize="14px"
                            _hover={{ bg: "rgb(40,45,100)" }}
                            disabled={selectedbanner.length >= 5}
                          >
                            Upload Banner
                          </Button>

                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="normal"
                            ms="4px"
                          >
                            {selectedbanner.length > 0
                              ? selectedbanner.length
                              : "No"}{" "}
                            Banner Selected
                          </Text>
                        </Flex>
                      </Flex>
                      <Flex wrap="wrap" justifyContent="flex-end" gap={4}>
                        {selectedbanner.map((src, index) => (
                          <Box
                            w="100%"
                            h="200px"
                            key={index}
                            boxSize="100px"
                            overflow={"hidden"}
                            borderRadius="10px"
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            position="relative"
                            mb={2}
                          >
                            <Image
                              src={src}
                              alt={`banner-${index}`}
                              w="auto"
                              h="200px"
                              boxSize="100%"
                              objectFit="contain"
                              borderRadius="10px"
                            />
                            <Button
                              size="xs"
                              position="absolute"
                              top="2px"
                              right="2px"
                              colorScheme="red"
                              borderRadius="full"
                              onClick={() => removeBannerItem(index)}
                            >
                              X
                            </Button>
                          </Box>
                        ))}
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Analytics
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="analytics"
                            onChange={handleChange}
                            isChecked={formData.analytics}
                          />
                        </Flex>
                      </Flex>
                      <Flex
                        justify="space-between"
                        align="center"
                        style={{
                          display: "none",
                        }}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Social Media
                        </FormLabel>
                        <Flex
                          justify="space-between"
                          align="center"
                          w="auto"
                          mb="20px"
                          gap={4}
                        >
                          <Switch
                            colorScheme="teal"
                            size="lg"
                            name="socialMedia"
                            isChecked={formData.socialMedia}
                            variant={"outline"}
                            onChange={handleChange}
                          />
                        </Flex>
                      </Flex>

                      <motion.div
                        initial={{
                          // height: formData.socialMedia ? 0 : 1,
                          // opacity: formData.socialMedia ? 0 : 1,
                          height: isShowAnalytics ? 0 : 1,
                          opacity: isShowAnalytics ? 0 : 1,
                        }}
                        animate={{
                          // height: formData.socialMedia ? "auto" : 0,
                          // opacity: formData.socialMedia ? 1 : 0,
                          height: isShowAnalytics ? "auto" : 0,
                          opacity: isShowAnalytics ? 1 : 0,
                        }}
                        transition={{ duration: 0.3 }}
                        // hidden={!formData.socialMedia}
                        hidden={!isShowAnalytics}
                      >
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Select Gender
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          h="50px"
                          w="100%"
                          borderRadius="20px"
                        >
                          <Select
                            color={titleColor}
                            bg="rgb(19,21,54)"
                            border="transparent"
                            borderRadius="20px"
                            fontSize="sm"
                            size="lg"
                            w="100%"
                            maxW="100%"
                            h="46px"
                            placeholder="Select Gender"
                            name="gender"
                            value={formData.gender || ""}
                            onChange={handleChange}
                            sx={{
                              option: {
                                backgroundColor: "rgb(19,21,54)",
                                color: "white",
                              },
                            }}
                          >
                            <option value="All">All</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </Select>
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Select Age Group
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          h="50px"
                          w="100%"
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Age Group"
                            options={ageGroupList}
                            selectedValue={selectedAgeGroup}
                            setSelectedValue={setSelectedAgeGroup}
                            isMulti={true}
                          />
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Location
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Locations"
                            options={locationList}
                            selectedValue={selectedLocation}
                            setSelectedValue={setSelectedLocation}
                            isMulti={true}
                          />
                        </GradientBorder>
                        <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Interests
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Interests"
                            options={interestsList}
                            selectedValue={selectedInterests}
                            setSelectedValue={setSelectedInterests}
                            isMulti={true}
                          />
                        </GradientBorder>

                        {/* <FormLabel
                          color={titleColor}
                          ms="4px"
                          fontSize="sm"
                          fontWeight="normal"
                        >
                          Targetings
                        </FormLabel>
                        <GradientBorder
                          mb="24px"
                          minH="50px"
                          w={{ base: "100%", lg: "100%" }}
                          borderRadius="20px"
                        >
                          <ChakraStyledSelect
                            placeholder="Select Targetings"
                            options={targetingList}
                            selectedValue={selectedTargeting}
                            setSelectedValue={setSelectedTargeting}
                            isMulti={true}
                          />
                        </GradientBorder> */}
                      </motion.div>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Additional Info
                      </FormLabel>

                      <GradientBorder
                        mb="14px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Textarea
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          rows={3}
                          overflowY={"auto"}
                          maxH="4.5em"
                          resize={"none"}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          type=""
                          placeholder="Additional Info"
                          name="additionalInfo"
                          value={formData.additionalInfo}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <Button
                        variant="brand"
                        fontSize="18px"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </form>
                </Flex>
              </GradientBorder>
            </Flex>
          </CardBody>
        </Card>

        {/* Preview */}
        <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <Flex direction="column">
            <CardHeader py="12px">
              <Text color="#fff" fontSize="lg" fontWeight="bold">
                Preview
              </Text>
            </CardHeader>
            <CardBody>
              <Flex direction="column" w="100%">
                {/* {billingData.map((row) => {
                  return (
                    <BillingRow
                      Order={row.Order}
                      campaign={row.campaign}
                      publisher={row.publisher}
                    />
                  );
                })} */}
                {Object.entries(formData).map(([key, value]) =>
                  value ? (
                    <Text
                      key={key}
                      color="#fff"
                      fontSize="lg"
                      fontWeight="500"
                      style={{
                        textTransform: "capitalize",
                        marginBottom: "10px",
                      }}
                    >
                      {key.replace(/([A-Z])/g, " $1")}:{" "}
                      {typeof value === "boolean" ? (
                        value ? (
                          "Yes"
                        ) : (
                          "No"
                        )
                      ) : key === "advertiser" ? (
                        data.find((item) => item.uuid === value).user.username
                      ) : key === "package" ? (
                        getOrderByType.find((item) => item.uuid === value)
                          .package_name
                      ) : key === "prgroup" ? (
                        groups.find((item) => item.uuid === value).group_name
                      ) : key === "content" ? (
                        formData?.content?.split("\\").pop()
                      ) : key === "banner" ? (
                        <Flex wrap="wrap" gap={4} mt={2}>
                          {selectedbanner.map((src, index) => (
                            <Box
                              w="100%"
                              h="200px"
                              key={index}
                              boxSize="100px"
                              overflow={"hidden"}
                              borderRadius="10px"
                              display={"flex"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              position="relative"
                            >
                              <Image
                                src={src}
                                alt={`banner-${index}`}
                                w="auto"
                                h="200px"
                                boxSize="100%"
                                objectFit="contain"
                                borderRadius="10px"
                              />
                            </Box>
                          ))}
                        </Flex>
                      ) : (
                        value
                      )}
                    </Text>
                  ) : null
                )}
              </Flex>
            </CardBody>
          </Flex>
        </Card>
      </Grid>
      <GroupModal setGroups={setGroups} isOpen={isOpen} setOpen={setIsOpen} />
    </Flex>
  );
}

export default CreateCampaign;
